export default __webpack_public_path__ + "static/media/preferenceIcon.62cdc6ea.svg";